﻿/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IConvosInputChecklistCreate,
  IConvosInputChecklistItemUpdate,
  IConvosInputCustomFieldValueSet,
  IConvosInputUpdateForKanban,
  IConvosInputCreate,
  IConvosInputReplyToCustomerOnly,
  IConvosInputReplyToCustomerWithUpdate,
  IConvosInputCommentOnly,
  IConvosInputCommentWithUpdate,
  IConvosInputManageCustomFilter,
  IConvosInputUpdateJobAppointee,
  IConvosInputEditComment,
  IConvosInputUpdateCustomFilter,
  IConvosInputBulkEditAssignee,
  IConvosInputBulkEditStatus,
  IConvosInputBulkEditPriorityLevel,
  IConvosInputBulkEditDueDate,
  IConvosInputBulkEditTags,
  IConvosInputBulkEditComment,
  IConvosInputBulkEditMailbox,
  IConvosInputBulkEditJobAppointee,
} from '../types/request.types'
import {
  IChecklistItem,
  ICustomFieldValue,
  IGenericJSONMessage,
  IConvosOutputSearchForKanban,
  IConvosOutputUpdateForKanban,
  IBulkEditOptions,
  IConvosOutputSearch,
  IConvoMergeInfo,
  IConvosOutputAllFilterOptions,
  IConvosOutputReplyVariableReplacements,
  IConvosOutputRecentlyCreatedForZapier,
  IItemsOutputRecentEventForZapier,
  IItemsOutputItemEventDescription,
  IConvosOutputFilterOptions,
  IConvosOutputDetail,
  ILastUpdatedEpochTime,
  ILinkedItemForListing,
  IConvosOutputHistoryv12,
  IItemResponder,
  IPostSuccess,
  IChecklist,
} from '../types/response.types'

export default new class ConvosAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_SearchForKanban(
    mailbox_id: any,
    customer_ids: string,
    is_spam: boolean,
    priority_ids: string,
    status_ids: string,
    status_type: string,
    assignee_ids: string,
    assigned_not_to_you: boolean,
    job_appointee_groupings_string: string,
    including_tag_ids: string,
    not_including_tag_ids: string,
    due_type: number,
    start_due_date: string,
    end_due_date: string,
    search_term: string,
    only_watching: boolean,
    created_within_days: number,
    last_updated_within_days: number,
    custom_field_filters: string = null,
  ): Promise<IConvosOutputSearchForKanban> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/search/for-kanban`,
      params: {
        customer_ids,
        is_spam,
        priority_ids,
        status_ids,
        status_type,
        assignee_ids,
        assigned_not_to_you,
        job_appointee_groupings_string,
        including_tag_ids,
        not_including_tag_ids,
        due_type,
        start_due_date,
        end_due_date,
        search_term,
        only_watching,
        created_within_days,
        last_updated_within_days,
        custom_field_filters,
      },
    })
  }
  public async get_BulkEditOptions(
    mailbox_ids: string,
  ): Promise<IBulkEditOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/options`,
      params: {
        mailbox_ids,
      },
    })
  }
  public async get_Search(
    page: number,
    mailbox_ids: string,
    customer_ids: string,
    sort: string,
    is_spam: boolean,
    priority_ids: string,
    status_ids: string,
    status_type: string,
    assignee_ids: string,
    assigned_not_to_you: boolean,
    job_appointee_groupings_string: string,
    including_tag_ids: string,
    not_including_tag_ids: string,
    due_type: number,
    start_due_date: string,
    end_due_date: string,
    search_term: string,
    only_watching: boolean,
    created_within_days: number,
    last_updated_within_days: number,
    custom_field_filters: string = null,
  ): Promise<IConvosOutputSearch> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/conversations/search`,
      params: {
        page,
        mailbox_ids,
        customer_ids,
        sort,
        is_spam,
        priority_ids,
        status_ids,
        status_type,
        assignee_ids,
        assigned_not_to_you,
        job_appointee_groupings_string,
        including_tag_ids,
        not_including_tag_ids,
        due_type,
        start_due_date,
        end_due_date,
        search_term,
        only_watching,
        created_within_days,
        last_updated_within_days,
        custom_field_filters,
      },
    })
  }
  public async get_MergePreview(
    mailbox_id: any,
    convo_ids_to_merge: string,
  ): Promise<IConvoMergeInfo> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/merge-preview`,
      params: {
        convo_ids_to_merge,
      },
    })
  }
  public async get_All_FilterOptions(
  ): Promise<IConvosOutputAllFilterOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/conversations/all/filter-options`,
    })
  }
  public async get_ReplyVariableReplacements(
    mailbox_id: any,
    customer_email: string,
  ): Promise<IConvosOutputReplyVariableReplacements> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/reply-variable-replacements`,
      params: {
        customer_email,
      },
    })
  }
  public async get_RecentlyCreatedForZapier(
    mailbox_id: any,
  ): Promise<IConvosOutputRecentlyCreatedForZapier> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/recently-created-for-zapier`,
    })
  }
  public async get_RecentEventsForZapier(
    mailbox_id: any,
  ): Promise<IItemsOutputRecentEventForZapier> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/recent-events-for-zapier`,
    })
  }
  public async get_EventDescription(
    mailbox_id: any,
    convo_id: any,
    convo_event_id: any,
  ): Promise<IItemsOutputItemEventDescription> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/event/${convo_event_id}/description`,
    })
  }
  public async get_FilterOptions(
    mailbox_id: any,
  ): Promise<IConvosOutputFilterOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/filter-options`,
    })
  }
  public async get_FilterOptionsWithConvoID(
    mailbox_id: any,
    convo_id: any,
  ): Promise<IConvosOutputFilterOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/filter-options`,
    })
  }
  public async get_Detail(
    mailbox_id: any,
    convo_id: any,
  ): Promise<IConvosOutputDetail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}`,
    })
  }
  public async get_LastUpdatedEpochTime(
    mailbox_id: any,
    convo_id: any,
  ): Promise<ILastUpdatedEpochTime> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/last-updated-epoch-time`,
    })
  }
  public async get_LinkedTasks(
    mailbox_id: any,
    convo_id: any,
  ): Promise<ILinkedItemForListing[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/linked-tasks`,
    })
  }
  public async get_History_v1_2(
    mailbox_id: any,
    convo_id: any,
    sort: string,
  ): Promise<IConvosOutputHistoryv12[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/history/v1.2`,
      params: {
        sort,
      },
    })
  }
  public async get_RespondersSinceLastViewed(
    mailbox_id: any,
    convo_id: any,
  ): Promise<IItemResponder[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/responders-since-last-viewed`,
    })
  }
  public async get_CustomFieldValues(
    mailbox_id: any,
    convo_id: any,
  ): Promise<ICustomFieldValue[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/custom-field-values`,
    })
  }
  /****** POST methods *****/
  public async post_Create(
    mailbox_id: any,
    data: IConvosInputCreate,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations`,
      data,
    })
  }
  public async post_ReplyToCustomerOnly(
    mailbox_id: any,
    convo_id: any,
    data: IConvosInputReplyToCustomerOnly,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/reply-only`,
      data,
    })
  }
  public async post_ReplyToCustomerWithUpdate(
    mailbox_id: any,
    convo_id: any,
    data: IConvosInputReplyToCustomerWithUpdate,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/reply-with-update`,
      data,
    })
  }
  public async post_CommentOnly(
    mailbox_id: any,
    convo_id: any,
    data: IConvosInputCommentOnly,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/comment-only`,
      data,
    })
  }
  public async post_CommentWithUpdate(
    mailbox_id: any,
    convo_id: any,
    data: IConvosInputCommentWithUpdate,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/comment-with-update`,
      data,
    })
  }
  public async post_LinkExistingTasks(
    mailbox_id: any,
    convo_id: any,
    listTaskIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/link-existing-tasks`,
      data: {
        listTaskIDs
      },
    })
  }
  public async post_CreateCustomFilter(
    data: IConvosInputManageCustomFilter,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/conversations/custom-filters`,
      data,
    })
  }
  public async post_BulkEdit_Comment(
    data: IConvosInputBulkEditComment,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/comment`,
      data,
    })
  }
  public async post_ChecklistCreate(
    mailbox_id: any,
    convo_id: any,
    data: IConvosInputChecklistCreate,
  ): Promise<IChecklist> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/checklist`,
      data,
    })
  }
  public async post_ChecklistItemCreate(
    mailbox_id: any,
    convo_id: any,
    checklist_id: any,
    name: string,
  ): Promise<IChecklistItem> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/checklist/${checklist_id}/checklist-item`,
      data: {
        name
      },
    })
  }
  /****** PUT methods *****/
  public async put_ChecklistItemUpdate(
    mailbox_id: any,
    convo_id: any,
    checklist_id: any,
    checklist_item_id: any,
    data: IConvosInputChecklistItemUpdate,
  ): Promise<IChecklistItem> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/checklist/${checklist_id}/checklist-item/${checklist_item_id}`,
      data,
    })
  }
  public async put_ChecklistItemUpdateSort(
    mailbox_id: any,
    convo_id: any,
    checklist_id: any,
    sorted_checklist_item_ids: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/checklist/${checklist_id}/checklist-item/sort`,
      data: {
        sorted_checklist_item_ids
      },
    })
  }
  public async put_CustomFieldValueSet(
    mailbox_id: any,
    convo_id: any,
    custom_field_id: any,
    data: IConvosInputCustomFieldValueSet,
  ): Promise<ICustomFieldValue> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/custom-field-values/${custom_field_id}`,
      data,
    })
  }
  public async put_UpdateForKanban(
    mailbox_id: any,
    convo_id: any,
    data: IConvosInputUpdateForKanban,
  ): Promise<IConvosOutputUpdateForKanban> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/for-kanban`,
      data,
    })
  }
  public async put_Subject(
    mailbox_id: any,
    convo_id: any,
    subject: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/subject`,
      data: {
        subject
      },
    })
  }
  public async put_Customer(
    mailbox_id: any,
    convo_id: any,
    to: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/customer`,
      data: {
        to
      },
    })
  }
  public async put_MarkAsSpam(
    mailbox_id: any,
    convo_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/mark-as-spam`,
    })
  }
  public async put_RemoveFromSpam(
    mailbox_id: any,
    convo_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/remove-from-spam`,
    })
  }
  public async put_Status(
    mailbox_id: any,
    convo_id: any,
    statusID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/status`,
      data: {
        statusID
      },
    })
  }
  public async put_PriorityLevel(
    mailbox_id: any,
    convo_id: any,
    priorityID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/priority`,
      data: {
        priorityID
      },
    })
  }
  public async put_Assignee(
    mailbox_id: any,
    convo_id: any,
    assigneeID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/assignee`,
      data: {
        assigneeID
      },
    })
  }
  public async put_JobAppointee(
    mailbox_id: any,
    convo_id: any,
    data: IConvosInputUpdateJobAppointee,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/job-appointee`,
      data,
    })
  }
  public async put_DueDate(
    mailbox_id: any,
    convo_id: any,
    dueDate: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/due-date`,
      data: {
        dueDate
      },
    })
  }
  public async put_Tags(
    mailbox_id: any,
    convo_id: any,
    listTags: string[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/tags`,
      data: {
        listTags
      },
    })
  }
  public async put_Watchers(
    mailbox_id: any,
    convo_id: any,
    listWatcherIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/watchers`,
      data: {
        listWatcherIDs
      },
    })
  }
  public async put_EditComment(
    mailbox_id: any,
    convo_id: any,
    convo_event_id: any,
    data: IConvosInputEditComment,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/comments/${convo_event_id}`,
      data,
    })
  }
  public async put_EditIncomingMessage(
    mailbox_id: any,
    convo_id: any,
    convo_event_id: any,
    message: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/incoming-messages/${convo_event_id}`,
      data: {
        message
      },
    })
  }
  public async put_UnlinkTask(
    mailbox_id: any,
    convo_id: any,
    task_id_to_unlink: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/unlink-task/${task_id_to_unlink}`,
    })
  }
  public async put_UpdateCustomFilter(
    custom_filter_id: any,
    data: IConvosInputUpdateCustomFilter,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/custom-filters/${custom_filter_id}`,
      data,
    })
  }
  public async put_BulkEdit_Assignee(
    data: IConvosInputBulkEditAssignee,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/assignee`,
      data,
    })
  }
  public async put_BulkEdit_Status(
    data: IConvosInputBulkEditStatus,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/status`,
      data,
    })
  }
  public async put_BulkEdit_PriorityLevel(
    data: IConvosInputBulkEditPriorityLevel,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/priority-level`,
      data,
    })
  }
  public async put_BulkEdit_DueDate(
    data: IConvosInputBulkEditDueDate,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/due-date`,
      data,
    })
  }
  public async put_BulkEdit_Tags(
    data: IConvosInputBulkEditTags,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/tags`,
      data,
    })
  }
  public async put_BulkEdit_Delete(
    listConversationIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/delete`,
      data: {
        listConversationIDs
      },
    })
  }
  public async put_BulkEdit_Mailbox(
    data: IConvosInputBulkEditMailbox,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/mailbox`,
      data,
    })
  }
  public async put_BulkEdit_Watch(
    listConversationIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/watch`,
      data: {
        listConversationIDs
      },
    })
  }
  public async put_BulkEdit_JobAppointee(
    data: IConvosInputBulkEditJobAppointee,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/job-appointee`,
      data,
    })
  }
  public async put_BulkEdit_Spam(
    listConversationIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/spam`,
      data: {
        listConversationIDs
      },
    })
  }
  public async put_BulkEdit_UnSpam(
    listConversationIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/conversations/bulk-edit/unspam`,
      data: {
        listConversationIDs
      },
    })
  }
  public async put_Merge(
    mailbox_id: any,
    listConversationIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/merge`,
      data: {
        listConversationIDs
      },
    })
  }
  public async put_ChecklistUpdate(
    mailbox_id: any,
    convo_id: any,
    checklist_id: any,
    title: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/checklist/${checklist_id}`,
      data: {
        title
      },
    })
  }
  /****** DELETE methods *****/
  public async delete_ChecklistItemDelete(
    mailbox_id: any,
    convo_id: any,
    checklist_id: any,
    checklist_item_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/checklist/${checklist_id}/checklist-item/${checklist_item_id}`,
    })
  }
  public async delete_CustomFieldValueDelete(
    mailbox_id: any,
    convo_id: any,
    custom_field_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/custom-field-values/${custom_field_id}`,
    })
  }
  public async delete_Delete(
    mailbox_id: any,
    convo_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}`,
    })
  }
  public async delete_ChecklistDelete(
    mailbox_id: any,
    convo_id: any,
    checklist_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/conversations/${convo_id}/checklist/${checklist_id}`,
    })
  }
}()
